import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { SideMenu } from '../../components/layouts/SideMenu';
import { Header } from '../../components/layouts/Header';
import { AppContainer, MainContentContainer, BodyContainer,WhiteContainer, AppButton } from '../../resources/styling/appStyle';
import { OutlinedInput, InputLabel, MenuItem, Select,CircularProgress,Grid, Chip, Stack, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Link, Modal, Box, Typography, FormControl, TextField, Collapse} from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { colors } from '../../resources/theme/colors';
import MuiDropDown from '../../components/common/MuiDropDown';
import AuditTrailDetails from '../../components/subscription/AuditTrailDetails';
import {
  FloatingInputLabel,
} from '../../components';
import { PRODUCT_NAMES, enforceSingleEiTier } from '../../utils/Constants';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import matGroupService from '../../services/api/matGroupService';
import { toast } from 'react-toastify';
import schoolService from '../../services/api/schoolService';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { getApiHookParams } from '../../auth';
import { format } from 'date-fns';


const { mandy, pictonBlue } = colors;
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  p: 3,
};


function EditSubscriptionSchool(props) {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [loadingProduct, setLoadingProduct] = useState(true);
  const [adminDashboardInfo, setAdminDashboardInfo] = useState({});
  const [productName, setProductName] = React.useState([]);
  const [selectedSchoolDetails, setSchoolDetails] = useState(null); // School details object
  const [SubscriptionTerm, setSubscriptionTerm] = useState('');

  const [selectedStartDate, setSelectedStartDate] = React.useState(null);
  const [selectedEndDate, setSelectedEndDate] = React.useState(null);
  // User Story 2: Product chargeability and mid-term detection
  const [productChargeability, setProductChargeability] = React.useState({});
  const [isMidTerm, setIsMidTerm] = React.useState(false);
  const [proRatedAmount, setProRatedAmount] = React.useState(0);
  const [unpaidInvoices, setUnpaidInvoices] = React.useState([]);
  const [showProRatingWarning, setShowProRatingWarning] = React.useState(false);
  // User Story 2: AC 2.2 - Audit trail
  const [auditTrail, setAuditTrail] = React.useState([]);
  const [auditTrailLoading, setAuditTrailLoading] = React.useState(false);
  const [auditTrailExpanded, setAuditTrailExpanded] = React.useState(false);

// WI-434: use the central product list so new tiers + relabels stay in sync. This is the
// EDIT screen for an existing school, so retired products remain visible/selectable.
const names = PRODUCT_NAMES;
const SubscriptionTermLst = [
  { id: 1, name: '1 Year' },
  { id: 2, name: '2 Years' },
  { id: 3, name: '3 Years' },   
];
  useEffect(() => {
      const params = new URLSearchParams(location.search);
      const querySchoolId = params.get('schoolId');
      const { schoolId: apiSchoolId } = getApiHookParams();
      const activeSchoolId = querySchoolId || apiSchoolId;

      if (!activeSchoolId) {
        toast.error('Unable to determine school ID.');
        setLoading(false);
        setLoadingProduct(false);
        return;
      }

      setLoading(true);
      setLoadingProduct(true);
      schoolService.getInfo(activeSchoolId)      
        .then((response) => {
          if (response && response.success && response.data) 
          {
            setAdminDashboardInfo(response);   
            setSchoolDetails(response.data);
            //prepopulate the already subscribed Products
            const matchedNames = response.data.schoolProductsList.map(item => {
              const match = names.find(n => n.id === item.Product);
              return match?.name; // optional chaining in case match is undefined
            }).filter(Boolean); // removes any undefined/null results
            setProductName(matchedNames);
            setSelectedStartDate(response.data.SchoolSubscription.StartDate);
            setSelectedEndDate(response.data.SchoolSubscription.EndDate);
            
            // User Story 2: AC 2.2 - Initialize product chargeability from backend data
            const chargeabilityMap = {};
            response.data.schoolProductsList.forEach(item => {
              const match = names.find(n => n.id === item.Product);
              if (match?.name) {
                // AC 2.7: Read actual chargeability from backend, default to true if not available
                chargeabilityMap[match.name] = item.IsChargeable !== undefined ? item.IsChargeable : true;
              }
            });
            // Also initialize any matched names that might not have chargeability data
            matchedNames.forEach(name => {
              if (!chargeabilityMap.hasOwnProperty(name)) {
                chargeabilityMap[name] = true; // Default to chargeable if not found in backend
              }
            });
            setProductChargeability(chargeabilityMap);
            
            // User Story 2: Check if subscription is mid-term
            const currentDate = new Date();
            const startDate = new Date(response.data.SchoolSubscription.StartDate);
            const endDate = new Date(response.data.SchoolSubscription.EndDate);
            const midTerm = currentDate >= startDate && currentDate < endDate;
            setIsMidTerm(midTerm);
            
            // User Story 2: Get unpaid invoices
            schoolService.GetUnpaidInvoices(activeSchoolId, null).then((invoiceResponse) => {
              if (invoiceResponse.success && invoiceResponse.data) {
                setUnpaidInvoices(invoiceResponse.data);
                if (invoiceResponse.data.length > 0 && midTerm) {
                  setShowProRatingWarning(true);
                }
              }
            }).catch(err => console.error('Error fetching unpaid invoices:', err));
            
            // User Story 2: AC 2.2 - Get audit trail for subscription
            const subscriptionId = response.data.SchoolSubscription?.Id;
            if (subscriptionId) {
              setAuditTrailLoading(true);
              schoolService.GetSubscriptionAuditTrail(activeSchoolId, null, subscriptionId).then((auditResponse) => {
                if (auditResponse.success && auditResponse.data) {
                  setAuditTrail(auditResponse.data);
                }
                setAuditTrailLoading(false);
              }).catch(err => {
                console.error('Error fetching audit trail:', err);
                setAuditTrailLoading(false);
              });
            }
            
            console.log("final Responce",matchedNames)    
            setLoading(false);        
            setLoadingProduct(false);  
          } else {
            console.error('Invalid response from getInfo:', response);
            toast.error('Failed to load school subscription data. Please try again.');
            setLoading(false);
            setLoadingProduct(false);
          }
        })
        .catch(err => {
          console.error('Error loading school subscription data:', err);
          toast.error('Error loading school subscription data. Please try again.');
          setLoading(false);
          setLoadingProduct(false);
        });               
    }, [location.search]);  

    const formatDate = (isoString) => {
      const date = new Date(isoString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    };
    
    // User Story 2: AC 2.2 - Calculate total subscription amount in real-time
    const calculateTotalAmount = (year1Cost, year2Cost, year3Cost, vatPercent, discount) => {
      const baseCost = parseFloat(year1Cost || 0) + parseFloat(year2Cost || 0) + parseFloat(year3Cost || 0);
      const afterDiscount = baseCost - parseFloat(discount || 0);
      const vatAmount = afterDiscount * (parseFloat(vatPercent || 20) / 100);
      return afterDiscount + vatAmount;
    };

    const handleProductChange = (event) => {
      const {
        target: { value },
      } = event;
      const rawProducts = typeof value === 'string' ? value.split(',') : value;
      // WI-434: only one EI tier may be active at a time.
      const newProducts = enforceSingleEiTier(rawProducts, productName);
      setProductName(newProducts);

      // User Story 2: Initialize chargeability for new products
      const newChargeability = { ...productChargeability };
      newProducts.forEach(product => {
        if (!newChargeability.hasOwnProperty(product)) {
          newChargeability[product] = true; // Default to chargeable
        }
      });
      setProductChargeability(newChargeability);
      
      // User Story 2: Calculate pro-rated amount if mid-term and new products added
      if (isMidTerm && selectedSchoolDetails?.SchoolSubscription) {
        const currentDate = new Date();
        const startDate = new Date(selectedSchoolDetails.SchoolSubscription.StartDate);
        const endDate = new Date(selectedSchoolDetails.SchoolSubscription.EndDate);
        const remainingDays = Math.max(0, Math.ceil((endDate - currentDate) / (1000 * 60 * 60 * 24)));
        const annualAmount = selectedSchoolDetails.SchoolSubscription.Year1Cost || 0;
        const dailyRate = annualAmount / 365;
        const proRated = dailyRate * remainingDays;
        setProRatedAmount(proRated);
        
        if (unpaidInvoices.length > 0 && newProducts.length > productName.length) {
          setShowProRatingWarning(true);
        }
      }
    };
    
    // User Story 2: Handle chargeability toggle
    const handleChargeabilityChange = (productName, isChargeable) => {
      setProductChargeability(prev => ({
        ...prev,
        [productName]: isChargeable
      }));
    };

    const subscriptionItems =
      SubscriptionTermLst.map((item) => {
          return (
          <MenuItem key={item.id} value={item.id}>
              {item.name}
          </MenuItem>
          );
      });

    const handleDelete = (id) => {
      // Handle delete action
      console.log('Delete item with ID:', id);
      // Update the data state by removing the item
      //setData(data.filter((item) => item.id !== id));
    };

    function setSubscriptionTerms(name) {    
      setSubscriptionTerm(name);
    }   
   
    


  return (
     loading===true? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <CircularProgress />
        </div>  
    ) : !selectedSchoolDetails || !selectedSchoolDetails.Id || !selectedSchoolDetails.SchoolSubscription ? (
        <AppContainer>
          <SideMenu />
          <MainContentContainer>
            <Header />
            <BodyContainer>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <WhiteContainer sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="h6" color="error" gutterBottom>
                      Unable to load subscription data
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      Please ensure a valid School ID is provided in the URL (e.g., ?schoolId=123)
                    </Typography>
                    <AppButton color={mandy} onClick={() => window.location.href = '/school-subscription-list'}>
                      Back to School Subscriptions
                    </AppButton>
                  </WhiteContainer>
                </Grid>
              </Grid>
            </BodyContainer>
          </MainContentContainer>
        </AppContainer>
    ) : (
        <Formik
              initialValues={{
                Id: selectedSchoolDetails.MatGroupId==null?0:selectedSchoolDetails.MatGroupId,
                Name: selectedSchoolDetails.Name==null?'':selectedSchoolDetails.Name,
                FirstName: selectedSchoolDetails.FirstName==null?'':selectedSchoolDetails.FirstName,
                LastName: selectedSchoolDetails.LastName==null?'':selectedSchoolDetails.LastName,
                Email: selectedSchoolDetails.Email==null?'':selectedSchoolDetails.Email,
                School: '',
                SchoolId: selectedSchoolDetails.Id,
                MatSchoolIds: [],
                GroupName: '',
                Group: '',
                CustomGroup: '',
                Username: '',
                isTestAccount: false,
                File: null,
                FileName: null,
                MatSchoolProducts: '',   
                IsMatSubscriptionUpdate: false,                
    
                IsMATSubscription:false,
                IsMultiYear:true,// get value from selection
                SubscriptionTerm: selectedSchoolDetails.SchoolSubscription.SubscriptionTerm,// get value from selection
                Year1Cost:selectedSchoolDetails.SchoolSubscription.Year1Cost,// get value from selection
                Year2Cost:selectedSchoolDetails.SchoolSubscription.Year2Cost,// get value from selection
                Year3Cost:selectedSchoolDetails.SchoolSubscription.Year3Cost,// get value from selection
                VatPercentApplied:selectedSchoolDetails.SchoolSubscription.VatPercentApplied === 0?20:selectedSchoolDetails.SchoolSubscription.VatPercentApplied,// get value from selection
                Discount:selectedSchoolDetails.SchoolSubscription.Discount,// get value from selection
                PaymentCurrency:1,// get value from selection
                PaymentMode:1,// get value from selection       
                StartDate:selectedStartDate,
                EndDate:selectedEndDate,           
              }}
              onSubmit={(values, actions) => {
                //debugger;
                const { loaderActions } = props;
                setLoading(true);
                //values.MatSchoolIds = matSchoolId;
                //alert(productName)
                if(values.FirstName=='')
                {
                    values.FirstName= values.GroupName;
                }
                if(values.LastName=='')
                {
                    values.LastName= values.GroupName;
                }
                
                // AC 2.6: Validate dates - end date must be after start date
                if (selectedStartDate && selectedEndDate) {
                  const startDate = new Date(selectedStartDate);
                  const endDate = new Date(selectedEndDate);
                  if (endDate <= startDate) {
                    toast.error('Subscription end date must be after the start date.');
                    setLoading(false);
                    return;
                  }
                }
                
                // User Story 2.4: Send product chargeability data to backend
                values.MatSchoolProducts = productName.map(name => ({
                  ProductName: name,
                  IsChargeable: productChargeability[name] !== false
                }));
                values.StartDate=selectedStartDate;
                values.EndDate=selectedEndDate;                       
                // loaderActions.dataLoading(true);
                matGroupService.UpdateMatSchoolSubscriptions(values).then((response) => {
                  const { success, message } = response;
                  // loaderActions.dataLoading(false);
                  setLoading(false);
                  if (success)
                  {
                      // User Story 2.3: Inform user about invoice actions
                      if (isMidTerm && unpaidInvoices.length > 0) {
                        toast.success('Subscription updated successfully. Previous unpaid invoices have been voided and a new invoice has been generated with pro-rated amounts.');
                      } else {
                        toast.success('School Subscription updated successfully');
                      }
                      // Reset warning state
                      setShowProRatingWarning(false);
                      // AC 2.2: Refresh audit trail after successful update
                      const params = new URLSearchParams(location.search);
                      const querySchoolId = params.get('schoolId');
                      const { schoolId: apiSchoolId } = getApiHookParams();
                      const activeSchoolId = querySchoolId || apiSchoolId;
                      const subscriptionId = selectedSchoolDetails.SchoolSubscription?.Id;
                      if (subscriptionId && activeSchoolId) {
                        setAuditTrailLoading(true);
                        schoolService.GetSubscriptionAuditTrail(activeSchoolId, null, subscriptionId).then((auditResponse) => {
                          if (auditResponse.success && auditResponse.data) {
                            setAuditTrail(auditResponse.data);
                          }
                          setAuditTrailLoading(false);
                        }).catch(err => {
                          console.error('Error refreshing audit trail:', err);
                          setAuditTrailLoading(false);
                        });
                      }
                  }
                  else
                  {
                      toast.error(message);
                  }
                });                
              }}              
              render={({
                values,
                handleChange,
                touched,
                errors,
                handleSubmit,
                setFieldValue,
              }) => (
                <div>
                <AppContainer>
                  <SideMenu />
                  <BodyContainer>
                    <Header />
                    <MainContentContainer>
                    {loading===true? (
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                          <CircularProgress />
                          </div>  
                    ) : (
                      <div>
                        {/* Group Detaill */}
                        <Grid container  mt={1}>
                          <Grid item xs={12} lg={12} md={12} sm={12}>
                            <h3>Edit Subscription</h3>
                          </Grid>

                          <Grid item xs={12} lg={12} md={12} sm={12}>              
                            <div className='subscription-detail'>
                              <Stack
                                direction='row'
                                spacing={0.8}
                                alignItems='center'
                                justifyContent='space-between'
                              >
                                <div>
                                  <Stack direction='row' spacing={0.8} alignItems="center" justifyContent="space-between">
                                  <p>
                                      <div>
                                          <strong>Subscription Term : {selectedSchoolDetails.SchoolSubscription.SubscriptionTerm} years. </strong> (Billed yearly)
                                      </div>
                                  </p>                        
                                  </Stack>
                                  <Stack direction='row' spacing={0.8} alignItems="center" justifyContent="space-between">
                                  <p>
                                      <div>
                                          <strong>Subscription Cost.</strong>
                                      </div>
                                      {selectedSchoolDetails.SchoolSubscription.SubscriptionTerm === 1 ? (
                                          <>                        
                                          <div>
                                              <strong>Year 1 : £{parseInt(selectedSchoolDetails.SchoolSubscription.Year1Cost)+((parseInt(selectedSchoolDetails.SchoolSubscription.Year1Cost) )*(parseInt(selectedSchoolDetails.SchoolSubscription.VatPercentApplied)/100))}</strong> ({selectedSchoolDetails.SchoolSubscription.VatPercentApplied}% VAT Applied)
                                          </div>                            
                                          </>
                                      ) : selectedSchoolDetails.SchoolSubscription.SubscriptionTerm === 2 ? (
                                          <>                        
                                          <div>
                                              <strong>Year 1 : £{parseInt(selectedSchoolDetails.SchoolSubscription.Year1Cost)+((parseInt(selectedSchoolDetails.SchoolSubscription.Year1Cost) )*(parseInt(selectedSchoolDetails.SchoolSubscription.VatPercentApplied)/100))}</strong> ({selectedSchoolDetails.SchoolSubscription.VatPercentApplied}% VAT Applied)
                                          </div>
                                          <div>
                                              <strong>Year 2 : £{parseInt(selectedSchoolDetails.SchoolSubscription.Year2Cost)+((parseInt(selectedSchoolDetails.SchoolSubscription.Year2Cost) )*(parseInt(selectedSchoolDetails.SchoolSubscription.VatPercentApplied)/100))}</strong> ({selectedSchoolDetails.SchoolSubscription.VatPercentApplied}% VAT Applied)
                                          </div>                           
                                          </>
                                      ) : selectedSchoolDetails.SchoolSubscription.SubscriptionTerm === 3 ? (
                                          <>                        
                                          <div>
                                              <strong>Year 1 : £{parseInt(selectedSchoolDetails.SchoolSubscription.Year1Cost)+((parseInt(selectedSchoolDetails.SchoolSubscription.Year1Cost) )*(parseInt(selectedSchoolDetails.SchoolSubscription.VatPercentApplied)/100))}</strong> ({selectedSchoolDetails.SchoolSubscription.VatPercentApplied}% VAT Applied)
                                          </div>
                                          <div>
                                              <strong>Year 2 : £{parseInt(selectedSchoolDetails.SchoolSubscription.Year2Cost)+((parseInt(selectedSchoolDetails.SchoolSubscription.Year2Cost) )*(parseInt(selectedSchoolDetails.SchoolSubscription.VatPercentApplied)/100))}</strong> ({selectedSchoolDetails.SchoolSubscription.VatPercentApplied}% VAT Applied)
                                          </div>
                                          <div>
                                              <strong>Year 3 : £{parseInt(selectedSchoolDetails.SchoolSubscription.Year3Cost)+((parseInt(selectedSchoolDetails.SchoolSubscription.Year3Cost) )*(parseInt(selectedSchoolDetails.SchoolSubscription.VatPercentApplied)/100))}</strong> ({selectedSchoolDetails.SchoolSubscription.VatPercentApplied}% VAT Applied)
                                          </div>
                                          </>
                                      ) : (
                                      "£0"
                                      )}   
                                  </p>                                                  
                                  </Stack>
                                  <p>Your License runs from <span>{formatDate(selectedSchoolDetails.SchoolSubscription.StartDate)} - {formatDate(selectedSchoolDetails.SchoolSubscription.EndDate)}</span></p>
                                </div> 

                                <div className='subscription-links'>
                                  <Link href="#" underline="hover" mb={3}>Change to monthly billing</Link>
                                  <Link href="#" underline="hover">Cancel subscription renewal</Link>                    
                                </div>                 
                              </Stack>
                              
                            </div>
                          </Grid>
                        </Grid>          

                        {/* User Story 2: Pro-rating Warning */}
                        {showProRatingWarning && isMidTerm && unpaidInvoices.length > 0 && (
                          <Grid container mt={3}>
                            <Grid item xs={12}>
                              <Box sx={{ 
                                p: 2, 
                                bgcolor: 'warning.light', 
                                borderRadius: 1,
                                border: '1px solid',
                                borderColor: 'warning.main'
                              }}>
                                <Typography variant="body2" color="warning.dark">
                                  <strong>Warning:</strong> Adding products mid-term will void existing unpaid invoices and generate a new invoice with pro-rated amounts. 
                                  Estimated pro-rated amount: £{proRatedAmount.toFixed(2)}
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        )}

                        {/* Products */}
                        <Grid container mt={3}>
                          <Grid item xs={12} lg={12} md={12} sm={12} mb={1}>
                            <h4>Products</h4>
                            <Typography variant="caption" color="text.secondary">
                              Check the box next to each product to mark it as chargeable (default: chargeable)
                            </Typography>
                          </Grid>
                          <Grid item xs={12} lg={12} md={12} sm={12}>
                            <FormControl fullWidth>      
                              <InputLabel id="add-products">Select Products</InputLabel>   
                              {(loadingProduct===true && productName.length <= 0) ? (
                                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                  <CircularProgress />
                                  </div>  
                              ) : (                               
                              <Select                                    
                                id="add-prodcuts"
                                multiple
                                //labelId='add-products'
                                value={productName}
                                label="Select Products"
                                onChange={handleProductChange}
                                input={<OutlinedInput id="select-multiple-chip" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => (
                                        <Chip 
                                          key={value} 
                                          className='schoolname-chip' 
                                          label={`${value} ${productChargeability[value] !== false ? '(Chargeable)' : '(Non-chargeable)'}`}
                                          onDelete={handleDelete}
                                          color={productChargeability[value] !== false ? 'primary' : 'default'}
                                        />
                                    ))}
                                    </Box>
                                )}
                                //MenuProps={MenuProps}
                              >
                                {names.map((item) => (
                                    <MenuItem
                                    key={item.id}
                                    value={item.name}                                        
                                    >
                                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                                      <span>{item.name}</span>
                                      {productName.includes(item.name) && (
                                        <input
                                          type="checkbox"
                                          checked={productChargeability[item.name] !== false}
                                          onChange={(e) => handleChargeabilityChange(item.name, e.target.checked)}
                                          onClick={(e) => e.stopPropagation()}
                                          style={{ marginLeft: '10px' }}
                                          title={productChargeability[item.name] !== false ? "Chargeable" : "Non-chargeable"}
                                        />
                                      )}
                                    </Stack>
                                    </MenuItem>
                                ))}
                              </Select>
                               )}
                            </FormControl>
                          </Grid>
                        </Grid>

                        {/* Billing Information */}
                        <Grid container mt={3}>
                          <Grid item xs={12} lg={12} md={12} sm={12}>
                            <h4 style={{marginBottom: '10px'}}>Billing Information</h4>              
                            <WhiteContainer>
                              <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} justifyContent="space-between">
                                <div>
                                  <h4>{selectedSchoolDetails.Name}</h4>
                                  <p>{selectedSchoolDetails.Email}</p>
                                </div>
                                <div className='subscription-links'>
                                  <Link href="#" underline="hover" mb={2}>Billing History</Link>
                                  <Link href="#" underline="hover">Change billing information</Link>                    
                                </div>
                              </Stack>
                            </WhiteContainer>
                          </Grid>
                        </Grid>

                        {/* Subscription cost */}
                        <Grid container mt={3}>
                            <Grid item xs={12} lg={6} md={7} sm={12}>
                                <div className='cost-panel'>
                                  <div>
                                    <h3>Subscription Cost</h3>
                                    {/* <span><Link>Edit</Link></span> */}
                                </div>
                                <div  style={{paddingTop:'10px'}}>
                                        <div className='label'>Subscription Term</div> 
                                        <FormControl fullWidth sx={{marginTop: 1}}>                                                                                                                                            
                                            <MuiDropDown                                                            
                                                name='SubscriptionTerm'
                                                //label='Subscription Terms'                                                        
                                                value={values.SubscriptionTerm}
                                                //value={selectedMatDetails.MatSubscription.SubscriptionTerm}
                                                onChange={(e) => {
                                                    setFieldValue('SubscriptionTerm', e.target.value);                                                      
                                                    setSubscriptionTerms(e.target.value);
                                                }}
                                            >
                                                {subscriptionItems}
                                            </MuiDropDown>
                                        </FormControl>
                                    </div>
                                    <div>
                                    <div className='label' style={{paddingTop:'10px'}}>Subscription Schedule</div> 
                                    <div  style={{paddingTop:'15px'}} >
                                      <FormControl>                                                                                                                                            
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                          <DatePicker
                                            label="Select Start date"
                                              name='StartDate'
                                            value={selectedStartDate}
                                            onChange={(newValue) => setSelectedStartDate(newValue)}
                                            renderInput={(params) => <TextField {...params} />}
                                          />
                                        </LocalizationProvider>
                                      </FormControl>
                                      <FormControl style={{paddingLeft:'30px'}}>    
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                          <DatePicker
                                            label="Select End date"
                                              name='EndDate'
                                            value={selectedEndDate}
                                            onChange={(newValue) => setSelectedEndDate(newValue)}
                                            renderInput={(params) => <TextField {...params} />}
                                          />
                                        </LocalizationProvider>
                                      </FormControl>
                                    </div>
                                </div>
                                    <div className='yearly-cost'>
                                      <div>
                                        <div className='label'>Year 1 Cost (£)</div>
                                        <FormControl>
                                          <FloatingInputLabel
                                            label='Year 1 Cost'                                                   
                                            name='Year1Cost'
                                            value={values.Year1Cost}
                                            //value={selectedMatDetails.MatSubscription.Year1Cost}
                                            onChange={handleChange}
                                          />
                                        </FormControl>
                                      </div>
                                      <div>
                                        <div className='label'>Year 2 Cost (£)</div>
                                        <FormControl>
                                          <FloatingInputLabel
                                            label='Year 2 Cost'                                                   
                                            name='Year2Cost'
                                            value={values.Year2Cost}
                                            //value={selectedMatDetails.MatSubscription.Year2Cost}
                                            onChange={handleChange}
                                          />
                                        </FormControl>
                                      </div>
                                      <div>
                                        <div className='label'>Year 3 Cost (£)</div>
                                        <FormControl>
                                          <FloatingInputLabel
                                            label='Year 3 Cost'                                                  
                                            name='Year3Cost'
                                            value={values.Year3Cost}
                                            //value={selectedMatDetails.MatSubscription.Year3Cost}
                                            onChange={handleChange}
                                          />
                                        </FormControl>
                                      </div>
                                      <div>
                                        <div className='label'>Discount (£)</div>
                                        <FormControl>
                                          <FloatingInputLabel
                                            label='Discount'                                                    
                                            name='Discount'
                                            value={values.Discount}
                                            //value={selectedMatDetails.MatSubscription.Discount}
                                            onChange={handleChange}
                                          />
                                        </FormControl>
                                      </div>
                                      <div>
                                        <div className='label'>VAT 
                                          (%)</div>
                                        <FormControl>
                                          <FloatingInputLabel                                                  
                                            label='Vat (%)'                                                   
                                            name='VatPercentApplied'
                                            value={values.VatPercentApplied}
                                            //value={selectedMatDetails.MatSubscription.VatPercentApplied}
                                            onChange={handleChange}
                                          />
                                        </FormControl>
                                      </div>
                                    </div>
                                    <hr/>
                                    <Stack direction="row" justifyContent='space-between' alignItems='center'>
                                        <p><strong>Final Total</strong></p>
                                        <p><strong>£{calculateTotalAmount(values.Year1Cost, values.Year2Cost, values.Year3Cost, values.VatPercentApplied, values.Discount).toFixed(2)}</strong></p>
                                    </Stack>
                                    {/* User Story 2: AC 2.2 - Show breakdown of calculation */}
                                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                                      Subtotal: £{((parseFloat(values.Year1Cost || 0) + parseFloat(values.Year2Cost || 0) + parseFloat(values.Year3Cost || 0)) - parseFloat(values.Discount || 0)).toFixed(2)} 
                                      (after discount: £{parseFloat(values.Discount || 0).toFixed(2)}) | 
                                      VAT ({values.VatPercentApplied || 20}%): £{(((parseFloat(values.Year1Cost || 0) + parseFloat(values.Year2Cost || 0) + parseFloat(values.Year3Cost || 0)) - parseFloat(values.Discount || 0)) * (parseFloat(values.VatPercentApplied || 20) / 100)).toFixed(2)}
                                    </Typography>
                                </div>
                            </Grid>
                        </Grid>

                        {/* User Story 2: AC 2.2 - Audit Trail Section */}
                        <Grid container mt={3}>
                          <Grid item xs={12} lg={12} md={12} sm={12}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                              <h4>Subscription Change History (Audit Trail)</h4>
                              <IconButton
                                onClick={() => setAuditTrailExpanded(!auditTrailExpanded)}
                                size="small"
                              >
                                {auditTrailExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                              </IconButton>
                            </Stack>
                            <Collapse in={auditTrailExpanded}>
                              {auditTrailLoading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                                  <CircularProgress size={24} />
                                </Box>
                              ) : auditTrail && auditTrail.length > 0 ? (
                                <WhiteContainer>
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell><strong>Date & Time</strong></TableCell>
                                        <TableCell><strong>Change Type</strong></TableCell>
                                        <TableCell><strong>Changed By</strong></TableCell>
                                        <TableCell><strong>Details</strong></TableCell>
                                        <TableCell><strong>Notes</strong></TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {auditTrail.map((entry, index) => (
                                        <TableRow key={entry.Id || index}>
                                          <TableCell>
                                            {entry.ChangedDate ? format(new Date(entry.ChangedDate), 'MMM dd, yyyy HH:mm:ss') : 'N/A'}
                                          </TableCell>
                                          <TableCell>{entry.ChangeType || 'N/A'}</TableCell>
                                          <TableCell>{entry.ChangedBy || 'System'}</TableCell>
                                          <TableCell>
                                            <AuditTrailDetails oldValue={entry.OldValue} newValue={entry.NewValue} />
                                          </TableCell>
                                          <TableCell>
                                            <Typography 
                                              variant="caption" 
                                              color="text.secondary"
                                              sx={{ 
                                                wordBreak: 'break-word',
                                                overflowWrap: 'break-word',
                                                maxWidth: '300px',
                                                whiteSpace: 'normal'
                                              }}
                                            >
                                              {entry.Notes || 'No notes'}
                                            </Typography>
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </WhiteContainer>
                              ) : (
                                <WhiteContainer>
                                  <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: 'center' }}>
                                    No audit trail entries found.
                                  </Typography>
                                </WhiteContainer>
                              )}
                            </Collapse>
                          </Grid>
                        </Grid>

                        {/* Payment Details */}
                        <Grid container mt={3}>
                          <Grid item xs={12} lg={12} md={12} sm={12}>
                            <h4 style={{marginBottom: '10px'}}>Payment Detail</h4>              
                            <WhiteContainer>
                              <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} justifyContent="space-between">
                                <Stack direction="row" spacing={1} alignItems="center">
                                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="40" height="40" rx="4" fill="#E2E2E2"/>
                                    <path d="M27.7773 11.1484H12.2227C10.6826 11.1484 9.42969 12.4014 9.42969 13.9414V26.0586C9.42969 27.5986 10.6826 28.8516 12.2227 28.8516H27.7773C29.3174 28.8516 30.5703 27.5986 30.5703 26.0586V13.9414C30.5703 12.4014 29.3174 11.1484 27.7773 11.1484ZM12.2227 13.2969H27.7773C28.1327 13.2969 28.4219 13.586 28.4219 13.9414V15.4453H11.5781V13.9414C11.5781 13.586 11.8673 13.2969 12.2227 13.2969ZM27.7773 26.7031H12.2227C11.8673 26.7031 11.5781 26.414 11.5781 26.0586V17.5938H28.4219V26.0586C28.4219 26.414 28.1327 26.7031 27.7773 26.7031Z" fill="black"/>
                                    <path d="M14.5859 22.4062C13.8751 22.4062 13.2969 22.9845 13.2969 23.6953C13.2969 24.4061 13.8751 24.9844 14.5859 24.9844C15.2967 24.9844 15.875 24.4061 15.875 23.6953C15.875 22.9845 15.2967 22.4062 14.5859 22.4062ZM17.1641 22.4062C16.4533 22.4062 15.875 22.9845 15.875 23.6953C15.875 24.4061 16.4533 24.9844 17.1641 24.9844C17.8749 24.9844 18.4531 24.4061 18.4531 23.6953C18.4531 22.9845 17.8749 22.4062 17.1641 22.4062Z" fill="black"/>
                                  </svg>                    
                                  <span>************1234</span>
                                </Stack>
                                <div className='subscription-links'>
                                  <Link href="#" underline="hover">Update payment details</Link>                    
                                </div>
                              </Stack>
                            </WhiteContainer>
                          </Grid>
                        </Grid>

                         <Grid item xs={12} lg={4} md={4} sm={12}></Grid>
                          <Grid item xs={12} lg={12} md={12} sm={12} mt={1} textAlign='right'>
                                <AppButton
                                  color={mandy}
                                  type='submit'
                                  onClick={handleSubmit}
                                  >
                                  Update School Subscription
                              </AppButton>                               
                          </Grid>
                      </div>
                    )}        
                    </MainContentContainer>
                  </BodyContainer>
                </AppContainer>
            </div>
              )}
        />
  ));
}

export default withRouter(EditSubscriptionSchool);
